import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { signUp } from '../../api/auth';
import styles from '../../styles/Auth.module.css';
export function SignupPage() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            const result = await signUp.email({ name, email, password });
            if (result.error) {
                setError(result.error.message || 'Ошибка регистрации');
                setLoading(false);
            }
            else {
                // Full reload to pick up the new session cookie
                window.location.replace('/');
            }
        }
        catch {
            setError('Ошибка соединения с сервером');
            setLoading(false);
        }
    };
    return (_jsx("div", { className: styles.container, children: _jsxs("div", { className: styles.card, children: [_jsx("h1", { className: styles.title, children: "\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F" }), _jsxs("form", { onSubmit: handleSubmit, className: styles.form, children: [_jsxs("label", { className: styles.label, children: ["\u0418\u043C\u044F", _jsx("input", { type: "text", value: name, onChange: (e) => setName(e.target.value), className: styles.input, required: true, autoFocus: true })] }), _jsxs("label", { className: styles.label, children: ["Email", _jsx("input", { type: "email", value: email, onChange: (e) => setEmail(e.target.value), className: styles.input, required: true })] }), _jsxs("label", { className: styles.label, children: ["\u041F\u0430\u0440\u043E\u043B\u044C", _jsx("input", { type: "password", value: password, onChange: (e) => setPassword(e.target.value), className: styles.input, required: true, minLength: 8 })] }), error && _jsx("div", { className: styles.error, children: error }), _jsx("button", { type: "submit", className: styles.button, disabled: loading, children: loading ? 'Регистрация...' : 'Зарегистрироваться' })] }), _jsxs("p", { className: styles.link, children: ["\u0423\u0436\u0435 \u0435\u0441\u0442\u044C \u0430\u043A\u043A\u0430\u0443\u043D\u0442? ", _jsx(Link, { to: "/login", children: "\u0412\u043E\u0439\u0442\u0438" })] })] }) }));
}
